import { Modal } from "../UI/Modal/Modal.tsx";
import { formatDateTime } from "../UI/Utils/formatDate.ts";
import dayjs from "dayjs";
import { TeacherSubstitutionResultGraphqlDto } from "../gql/graphql.ts";

export function SubstitutionResultModal({
  show,
  onClose,
  result,
}: {
  show: boolean;
  onClose: () => void;
  result: TeacherSubstitutionResultGraphqlDto | null;
}) {
  if (!result) return null;

  const hasSuccesses = result.successfulSubstitutions.length > 0;
  const hasFailures = result.failedSubstitutions.length > 0;

  return (
    <Modal
      isOpen={show}
      onClose={onClose}
      title="Risultato Sostituzione Automatica"
    >
      <div>
        {hasSuccesses && (
          <div className="mb-6">
            <h3 className="text-lg font-medium text-green-700 mb-3">
              ✓ Sostituzioni riuscite ({result.successfulSubstitutions.length})
            </h3>
            <div className="space-y-3">
              {result.successfulSubstitutions.map((sub, index) => (
                <div
                  key={index}
                  className="p-4 bg-green-50 border border-green-200 rounded-md"
                >
                  <div className="text-sm space-y-1">
                    <div>
                      <span className="font-medium">Data:</span>{" "}
                      {formatDateTime(sub.startDateUtc, { locale: "it" })} -{" "}
                      {dayjs(sub.endDateUtc).format("HH:mm")}
                    </div>
                    <div>
                      <span className="font-medium">Classe:</span>{" "}
                      {sub.isOnboardingLive
                        ? "Live onboarding"
                        : "Lezione di gruppo"}
                    </div>
                    <div>
                      <span className="font-medium">Insegnante originale:</span>{" "}
                      {sub.originalTeacher.givenName}{" "}
                      {sub.originalTeacher.familyName} (
                      {sub.originalTeacher.email})
                    </div>
                    <div>
                      <span className="font-medium">Nuovo insegnante:</span>{" "}
                      {sub.newTeacher.givenName} {sub.newTeacher.familyName} (
                      {sub.newTeacher.email})
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {hasFailures && (
          <div className="mb-6">
            <h3 className="text-lg font-medium text-red-700 mb-3">
              ✗ Sostituzioni fallite ({result.failedSubstitutions.length})
            </h3>
            <div className="space-y-3">
              {result.failedSubstitutions.map((sub, index) => (
                <div
                  key={index}
                  className="p-4 bg-red-50 border border-red-200 rounded-md"
                >
                  <div className="text-sm space-y-1">
                    <div>
                      <span className="font-medium">Data:</span>{" "}
                      {formatDateTime(sub.startDateUtc, { locale: "it" })} -{" "}
                      {dayjs(sub.endDateUtc).format("HH:mm")}
                    </div>
                    {sub.teacher && (
                      <div>
                        <span className="font-medium">Insegnante:</span>{" "}
                        {sub.teacher.givenName} {sub.teacher.familyName} (
                        {sub.teacher.email})
                      </div>
                    )}
                    <div>
                      <span className="font-medium">Motivo:</span> {sub.reason}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {!hasSuccesses && !hasFailures && (
          <div className="text-center text-gray-500 py-4">
            Nessuna sostituzione da mostrare
          </div>
        )}
      </div>
    </Modal>
  );
}
